import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ClientItemCatalogComponent } from '@nebalkon-workspace/cabinet-client';

@Component({
  selector: 'lib-staff-user-items-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ClientItemCatalogComponent],
  template: `<lib-client-item-catalog headerMode="inline" />`,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
  `,
})
export class StaffUserItemsListComponent {}
